
// $(document).ready(function () {
//     // var swiper = new Swiper(".js-service-banner", {
//     //     // slidesPerView: "auto",
//     //     // spaceBetween: 10,
//     //     // loop: true,
//     //     // speed: 3000,
//     //     // autoplay: {
//     //     //     delay: 1000,
//     //     // },    
//     //     navigation: {
//     //       nextEl: ".swiper-button-next",
//     //       prevEl: ".swiper-button-prev",
//     //     },
//     //   });
// })


$(document).ready(function () {
  var swiper = new Swiper(".swiper-container", {
    autoplay: {
      delay: 5000,
      disableOnInteraction: false
    },
    speed: 500,
    // loop: true,
    // // pagination: {
    //   el: ".swiper-pagination",
    //   type: "fraction"
    // },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    },
    on: {
      init: function () {
        $(".swiper-progress-bar").removeClass("animate");
        $(".swiper-progress-bar").removeClass("active");
        $(".swiper-progress-bar").eq(0).addClass("animate");
        $(".swiper-progress-bar").eq(0).addClass("active");
      },
      slideChangeTransitionStart: function () {
        $(".swiper-progress-bar").removeClass("animate");
        $(".swiper-progress-bar").removeClass("active");
        $(".swiper-progress-bar").eq(0).addClass("active");
      },
      slideChangeTransitionEnd: function () {
        $(".swiper-progress-bar").eq(0).addClass("animate");
      }
    }
  });
  $('.swiper-container').hover(function() {
    swiper.autoplay.stop();
    $('.swiper-progress-bar').removeClass('animate');
  }, function(){
    swiper.autoplay.start();
    $('.swiper-progress-bar').addClass('animate');
  });
});



